import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Team(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Team", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M11.7612 22.7393c2.9175 0 5.2827-2.628 5.2827-5.8697S14.6787 11 11.7612 11c-2.91755 0-5.28268 2.6279-5.28268 5.8696 0 3.2417 2.36513 5.8697 5.28268 5.8697Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M11.7605 25.0869c-2.33508 0-4.57453.9895-6.22568 2.7507-1.65116 1.7613-2.57877 4.15-2.57877 6.6408H20.565c0-2.4908-.9277-4.8795-2.5788-6.6408-1.6512-1.7612-3.8906-2.7507-6.2257-2.7507Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M35.2397 22.7393c2.9176 0 5.2827-2.628 5.2827-5.8697S38.1573 11 35.2397 11c-2.9175 0-5.2826 2.6279-5.2826 5.8696 0 3.2417 2.3651 5.8697 5.2826 5.8697Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M35.239 25.0869c-2.3351 0-4.5745.9895-6.2257 2.7507-1.6511 1.7612-2.5787 4.15-2.5787 6.6407h17.6089c0-2.4907-.9276-4.8795-2.5788-6.6407-1.6512-1.7612-3.8906-2.7507-6.2257-2.7507ZM23.5006 26.261c2.9175 0 5.2827-2.6279 5.2827-5.8696 0-3.2417-2.3652-5.8697-5.2827-5.8697s-5.2827 2.628-5.2827 5.8697 2.3652 5.8696 5.2827 5.8696Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M23.4996 27.4348c-2.3351 0-4.5745 1.1131-6.2257 3.0945-1.6511 1.9814-2.5787 4.6687-2.5787 7.4708h17.6089c0-2.8021-.9276-5.4894-2.5788-7.4708-1.6511-1.9814-3.8906-3.0945-6.2257-3.0945Z",
        fill: theme.vars.palette.primary.light
      }
    )
  ] });
}
Team.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Team"
};
validateTidalLicense();
export {
  Team
};
//# sourceMappingURL=Team.js.map
